import moment from 'moment';
import React from 'react';
import { LoadingSpinner } from '../../../components';

const ByVoucherMobile = (props) => {
    const { isLoading, voucherList, winAmount, currentBalance } = props;
    console.log("voucherList", voucherList);
    return (
        <div>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <section className="flex flex-col items-center justify-center mt-4 shadow-lg p-2">
                    {
                    voucherList.length === 0 && (
                        <div className="text-center text-gray-500">
                            No vouchers found.
                        </div>
                    )}
                    {voucherList.map((voucher) => (
                        <div key={voucher.id} className="bg-white shadow-md rounded-lg p-4 mb-2 w-full max-w-md border-l-4 border-t-2 border-l-teal-500">
                            <div className="flex items-center justify-between">
                                <span className="text-base font-bold text-customForeColor">{voucher.postingNo}</span>
                                <span className={`text-sm ${voucher.active ? 'text-yellow-600' : 'text-green-600'} bg-gray-100 px-2 py-1 rounded`}>
                                    {voucher.active ? 'Active' : 'Finished'}
                                </span>
                            </div>

                            <div className='flex gap-3 items-center mb-4'>
                                <p className='text-xs font-semibold text-gray-500'>
                                    {moment(voucher.createdDate).format("YYYY-MM-DD hh:mm a")}
                                </p>
                                <p className="text-xs text-customFontVoilet bg-gray-100 px-2 py-1 rounded font-semibold">
                                    {voucher.gamblingTypeId === 1 ? "Single" : `Mix (${voucher.teamCount})`} </p>
                            </div>
                            <div className='flex flex-col justify-center'>
                                <p className='text-xs font-semibold text-gray-600'>Username</p>
                                <p className='text-sm font-bold text-customFontGold'>{voucher.username} ({voucher.name})</p>
                            </div>
                            <div className="flex justify-between mt-4">
                                <div className='flex flex-col items-center'>
                                    <span className="text-sm text-gray-600 font-semibold">Bet Amount</span>
                                    <span className="text-sm font-bold text-customFontGold">{voucher.amount}</span>
                                </div>
                                <div className='flex flex-col items-center'>
                                    <span className="text-sm text-gray-600 font-semibold">Win Amount</span>
                                    <span className="text-sm font-bold text-customFontGold">{winAmount}</span>
                                </div>
                                <div className='flex flex-col items-center'>
                                    <span className="text-sm text-gray-600 font-semibold">Current Amount</span>
                                    <span className="text-sm font-bold text-customFontGold">{currentBalance}</span>
                                </div>
                            </div>

                            <div className="flex justify-center items-center mt-4">
                                <button className="bg-customFontGreen text-white px-4 text-sm py-2 rounded hover:bg-blue-600">
                                    View Details
                                </button>
                            </div>
                        </div>
                    ))}
                </section>
            )}
        </div>
    )
}

export default ByVoucherMobile